<template>
    <div class="text-sm" :class="margin">
        <div class="text-gray-500 mb-1">
            <slot name="left"></slot>
        </div>
        <div class="font-semibold">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        margin: {
            type: String,
            default: "mb-5"
        },
    },
};
</script>
